<div style="height:300px">
  <div ngClass="reactivo mat-elevation-z4 p-20 mb-20" ngClass.gt-sm="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
      <h3 class="mt-0">Me dan los recursos y herramientas necesarias para hacer mi trabajo</h3>
      <div class="perspectivas" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign.gt-sm="space-between stretch" fxLayoutAlign="start stretch">
        <div ngClass="perspectiva_O mat-elevation-z4 p-20 mb-20" ngClass.gt-sm="perspectiva_O mat-elevation-z4 p-20" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="49">
          <h3 class="mt-0">Perspectiva de Organización</h3>
          <div class="" fxLayout="row" fxLayoutAlign="start stretch" >
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" fxFlex="100">
              <mat-button-toggle value="bold" fxFlex="20" class="survico surv_ico1" >
                <div class="txtbt">
                  Almost always untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="italic"fxFlex="20" class="survico surv_ico2">
                <div class="txtbt">
                  Often untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20" class="survico surv_ico3">
                <div class="txtbt">
                  Sometimes true / sometimes untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico4">
                <div class="txtbt">
                  Often true
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico5">
                <div class="txtbt">
                  Almost always true
                </div>

              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="perspectiva_A mat-elevation-z4 p-20 " fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="49">
          <h3 class="mt-0">Perspectiva de Área</h3>
          <div class="" fxLayout="row" fxLayoutAlign="start stretch">
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" fxFlex="100">
              <mat-button-toggle value="bold" fxFlex="20" class="survico surv_ico1" >
                <div class="txtbt">
                  Almost always untrue
                </div>

              </mat-button-toggle>
              <mat-button-toggle value="italic"fxFlex="20" class="survico surv_ico2">
                <div class="txtbt">
                  Often untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20" class="survico surv_ico3">
                <div class="txtbt">
                  Sometimes true / sometimes untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico4">
                <div class="txtbt">
                  Often true
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico5">
                <div class="txtbt">
                  Almost always true
                </div>

              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    </div>

  <div ngClass="reactivo mat-elevation-z4 p-20 mb-20" ngClass.gt-sm="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
      <h3 class="mt-0">Me dan los recursos y herramientas necesarias para hacer mi trabajo</h3>
      <div class="perspectivas" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign.gt-sm="space-between stretch" fxLayoutAlign="start stretch">
        <div ngClass="perspectiva_O mat-elevation-z4 p-20 mb-20" ngClass.gt-sm="perspectiva_O mat-elevation-z4 p-20" fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="49">
          <h3 class="mt-0">Perspectiva de Organización</h3>
          <div class="" fxLayout="row" fxLayoutAlign="start stretch" >
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" fxFlex="100">
              <mat-button-toggle value="bold" fxFlex="20" class="survico surv_ico1" >
                <div class="txtbt">
                  Almost always untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="italic"fxFlex="20" class="survico surv_ico2">
                <div class="txtbt">
                  Often untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20" class="survico surv_ico3">
                <div class="txtbt">
                  Sometimes true / sometimes untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico4">
                <div class="txtbt">
                  Often true
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico5">
                <div class="txtbt">
                  Almost always true
                </div>

              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="perspectiva_A mat-elevation-z4 p-20 " fxLayout="column" fxLayoutAlign="start stretch" fxFlex.gt-sm="49">
          <h3 class="mt-0">Perspectiva de Área</h3>
          <div class="" fxLayout="row" fxLayoutAlign="start stretch">
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" fxFlex="100">
              <mat-button-toggle value="bold" fxFlex="20" class="survico surv_ico1" >
                <div class="txtbt">
                  Almost always untrue
                </div>

              </mat-button-toggle>
              <mat-button-toggle value="italic"fxFlex="20" class="survico surv_ico2">
                <div class="txtbt">
                  Often untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20" class="survico surv_ico3">
                <div class="txtbt">
                  Sometimes true / sometimes untrue
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico4">
                <div class="txtbt">
                  Often true
                </div>
              </mat-button-toggle>
              <mat-button-toggle value="underline"fxFlex="20"class="survico surv_ico5">
                <div class="txtbt">
                  Almost always true
                </div>

              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    </div>


</div>
